import apiInst from '../api.js';

class ValidationService {
  constructor() {
    console.log('Validation service inst');
  }

  getErrorCodes() {
    return apiInst.get('/validation/error-codes');
  }
}

export default new ValidationService();
